module.exports = __webpack_public_path__ + "static/work7-2ffe978bf5d878ca5b35d5233cc741fd.jpg";